import React from 'react'
import PropTypes from 'prop-types'
import { IconButton, Tooltip } from '@material-ui/core'
import { useUtilityPanel } from './UtilityPanelProvider'
import { useUtilityPanelStyles } from './utilityPanelStyles'

// Local copy of the LayoutIcon SVG from aiApp/Attachments/PanelToolbar.
// Kept local rather than imported to avoid a cross-app dependency for
// ~20 LOC of pixel-pushing. If we ever extract a shared utility panel,
// this can move with it.
function LayoutIcon ({ leftWeight, rightWeight, active }) {
  const total = leftWeight + rightWeight
  const leftW = Math.round((leftWeight / total) * 16)
  const rightW = 16 - leftW
  const gap = 1.5
  const fill = active ? 'var(--color-ai-600, #1976d2)' : 'currentColor'
  const opacity = active ? 1 : 0.5

  if (leftWeight === 0) {
    return (
      <svg width='18' height='14' viewBox='0 0 18 14' style={{ display: 'block' }}>
        <rect x='1' y='1' width='16' height='12' rx='1.5' fill={fill} opacity={opacity} />
      </svg>
    )
  }

  return (
    <svg width='18' height='14' viewBox='0 0 18 14' style={{ display: 'block' }}>
      <rect x='1' y='1' width={leftW - gap / 2} height='12' rx='1.5' fill={fill} opacity={opacity * 0.35} />
      <rect x={1 + leftW + gap / 2} y='1' width={rightW - gap / 2} height='12' rx='1.5' fill={fill} opacity={opacity} />
    </svg>
  )
}

LayoutIcon.propTypes = {
  leftWeight: PropTypes.number.isRequired,
  rightWeight: PropTypes.number.isRequired,
  active: PropTypes.bool
}

// Three presets only -- the grid is the primary surface in PA, so the
// "full" preset (panel takes the whole viewport) from the AI assistant
// pattern isn't useful here.
const PRESETS = [
  { mode: 'sidebar', left: 3, right: 1, label: 'Sidebar' },
  { mode: 'split', left: 1, right: 1, label: 'Split' },
  { mode: 'focus', left: 1, right: 3, label: 'Focus panel' }
]

export default function UtilityPanelToolbar ({ actions }) {
  const classes = useUtilityPanelStyles()
  const { layoutMode, setLayoutMode } = useUtilityPanel()

  return (
    <div className={classes.toolbar}>
      <div className={classes.toolbarLeft}>
        {PRESETS.map(({ mode, left, right, label }) => {
          const active = layoutMode === mode
          return (
            <Tooltip key={mode} title={label} placement='bottom' enterDelay={400}>
              <IconButton
                className={`${classes.layoutButton} ${active ? classes.layoutButtonActive : ''}`}
                onClick={() => setLayoutMode(mode)}
                size='small'
                aria-label={label}
                aria-pressed={active}
              >
                <LayoutIcon leftWeight={left} rightWeight={right} active={active} />
              </IconButton>
            </Tooltip>
          )
        })}
      </div>

      {actions && (
        <div className={classes.toolbarRight}>
          {actions}
        </div>
      )}
    </div>
  )
}

UtilityPanelToolbar.propTypes = {
  actions: PropTypes.node
}
